export const FETCH_OUT_OF_THE_OFFICE_STATUS = 'FETCH_OUT_OF_THE_OFFICE_STATUS';